import {Vue} from "nuxt-property-decorator";

export function showModal(component, options = {}) {
  if (process.server) return

  const rootInstance = window.$nuxt

  if (!rootInstance) {
    throw new Error('Не удалось получить инстанс приложения')
  }

  const ModalClass = Vue.extend(component)
  // @ts-ignore
  let modal: any = new ModalClass({...options, parent: rootInstance})

  modal.$on('close', (args) => {
    modal.$options?.on?.close(args)
    modal.$el.remove()
    modal = null
  })

  modal.$mount();
  rootInstance.$el.appendChild(modal.$el)

  return modal
}
